/**
 * Helpers internos de lectura de valores crudos de RTDB/REST, compartidos por
 * los modelos. No forman parte de la API pública del paquete.
 */

/** Equivalente a `value?.toString()` de Dart: null/undefined → null. */
export function toStr(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  return String(value);
}

/** Devuelve el objeto si `value` es un mapa (no array, no null); si no, null. */
export function asMap(value: unknown): Record<string, unknown> | null {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

/**
 * Estado remoto en RTDB: `server_phase` (autoridad) si viene no vacío; si no,
 * `status` crudo. Port de `_remoteStatusValue`.
 */
export function remoteStatusValue(data: Record<string, unknown>): string | null {
  const serverPhase = toStr(data['server_phase'])?.trim();
  if (serverPhase) return serverPhase;
  return toStr(data['status']);
}

/**
 * Estado en REST de rides: `phase` (granular) si viene no vacío; si no,
 * `status` crudo. Port de `_restStatusValue` (solo rides; las reservas REST
 * usan {@link remoteStatusValue}).
 */
export function restPhaseStatusValue(data: Record<string, unknown>): string | null {
  const phase = toStr(data['phase'])?.trim();
  if (phase) return phase;
  return toStr(data['status']);
}
